import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

// Resolve a stored image reference to a loadable URL.
// Backend uploads are stored as "/api/files/..." (relative) — prefix with backend.
export const resolveUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${BACKEND}${url}`;
  return url;
};

const TOKEN_KEY = "ml_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const adminLogin = async (password) => {
  const { data } = await axios.post(`${API}/auth/login`, { password });
  setToken(data.token);
  return data.token;
};

export const fetchContent = async () => {
  const { data } = await axios.get(`${API}/content`);
  return data;
};

export const verifyToken = async () => {
  const t = getToken();
  if (!t) return false;
  try {
    await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${t}` } });
    return true;
  } catch {
    clearToken();
    return false;
  }
};

export const saveContent = async (content) => {
  const { data } = await axios.put(`${API}/content`, content, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  return data;
};

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(`${API}/upload`, fd, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return data; // { path, url }
};
